import styled from '@emotion/styled';

export const Container = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
});

export const ContentWrapper = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
});

export const LogsWrapper = styled.div(({ theme }) => ({
  marginTop: '1rem',
  padding: '1rem',
  border: `1px solid ${theme.colors.gray[3]}`,
  borderRadius: theme.radius.sm,
  backgroundColor: 'white',
}));
